export const SET_WELCOME_MESSAGE_MODAL = "SET_WELCOME_MESSAGE_MODAL"